<template>
	<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
		<div class="row">
			<div class="col-md-3">
				<b>Ubicación</b>
				<a-select v-model="payload.branch_office_id" :style="{ width: '100%' }" @change="generateReport">
					<a-select-option value=""> Todas </a-select-option>
					<a-select-option v-for="(element, key) in branchOfficesList" :key="key" :value="element.id"> {{ element.branch_office_name }} </a-select-option>
				</a-select>
			</div>
			<div class="col-md-3">
				<b>Área</b>
				<a-select v-model="payload.area" :style="{ width: '100%' }" @change="generateReport">
					<a-select-option value=""> Todas </a-select-option>
					<a-select-option value="2"> Boutique </a-select-option>
					<a-select-option value="3"> Refacciones </a-select-option>
				</a-select>
			</div>
			<div class="col-md-3">
				<b>Rango de fecha</b>
				<a-range-picker style="width: 100%" v-model="payload.date" :format="dateFormat" @change="generateReport" />
			</div>
		</div>
		<hr />
		<div class="row" v-for="(element, index) in reportData" :key="index">
			<div class="col-md-12">
				<div>
					<h3 class="text-muted">{{ element.label }}</h3>
					<b>SKU:</b> {{ element.sku }}<br />
					<b>CANTIDAD:</b> {{ element.cantidad_total }}<br />
				</div>
			</div>
			<div class="col-md-12">
				<hr />
			</div>
		</div>
	</a-spin>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import numeral from 'numeral'
const dateFormat = 'DD-MM-YYYY'
import utilities from '@/services/utilities'

export default {
	name: 'posReportsComponent',
	computed: {
		...mapGetters('branchOffices', ['branchOfficesList']),
		spinnerLoader() {
			return this.$store.state.pos.spinnerLoader
		},
		spinnerLoaderLabel() {
			return this.$store.state.pos.spinnerLoaderLabel
		},
	},
	data() {
		return {
			numeral,
			utilities,
			dateFormat,
			payload: {
				branch_office_id: '',
				area: '',
				date: [
					moment().subtract(1, 'week').startOf('week').add(1, 'day').format('YYYY-MM-DD'), // lunes de la semana pasada
					moment().subtract(1, 'week').startOf('week').add(6, 'day').format('YYYY-MM-DD'), // sábado de la semana pasada
				],
				// date: [moment().format('YYYY-MM-DD').starOf('week').substract(1, 'week'), moment().format('YYYY-MM-DD').endOf('week').substract(1, 'week')],
			},
			reportData: [],
		}
	},
	beforeMount() {
		//
		if (this.branchOfficesList.length == 0) {
			this.$store.dispatch('branchOffices/GET')
		}
	},
	methods: {
		generateReport() {
			this.reportData = []
			let thePayload = {
				branch_office_id: utilities.objectValidate(this.payload, 'branch_office_id', ''),
				area: utilities.objectValidate(this.payload, 'area', ''),
				startDate: this.payload.date[0],
				endDate: this.payload.date[1],
			}
			this.$store.dispatch('pos/GET_SALES_REPORT', thePayload).then(async (response) => {
				// console.log('GET_SALES_REPORT--->', response)
				this.reportData = utilities.objectValidate(response, 'data', [])
			})
		},
	},
}
</script>